var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "language-component" }, [
    _c(
      "div",
      {
        staticClass: "user-box",
        style: {
          display: "inline-block",
          float: "right",
          width: "150px",
          textAlign: "left",
          fontSize: "16px",
          paddingTop: "2px",
        },
      },
      [
        _c(
          "el-dropdown",
          { on: { command: _vm.selectLanguage } },
          [
            _c(
              "span",
              {
                staticClass: "header-avatar",
                staticStyle: { cursor: "pointer" },
              },
              [
                _c("CustomPic"),
                _c("span", { staticStyle: { "margin-left": "5px" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("header.language") + "：" + _vm.activeLanguage
                    )
                  ),
                ]),
                _c("i", { staticClass: "el-icon-arrow-down" }),
              ],
              1
            ),
            _c(
              "el-dropdown-menu",
              {
                staticClass: "dropdown-group",
                attrs: { slot: "dropdown" },
                slot: "dropdown",
              },
              [
                _c(
                  "el-dropdown-item",
                  { attrs: { command: "zh-中文(简体)" } },
                  [_vm._v("中文(简体)")]
                ),
                _c("el-dropdown-item", { attrs: { command: "en-English" } }, [
                  _vm._v("English"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }